import { gql } from 'apollo-angular'

export const ARTICLE_INDEX = gql`
  query ArticleIndex($articleId: Int!) {
    articleIndex(articleId: $articleId) {
      title
      level
    }
  }
`
